function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Caixa de Di\xE1logo");

var SvgDialogue = function SvgDialogue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M73.12,27.27H22.88a2.06,2.06,0,0,0-2.06,2.05V66.49a2.07,2.07,0,0,0,2.06,2.06H73.12a2.07,2.07,0,0,0,2.06-2.06V29.32A2.06,2.06,0,0,0,73.12,27.27ZM72.07,65a.48.48,0,0,1-.47.48H52.84a.48.48,0,0,1-.47-.48V60a.47.47,0,0,1,.47-.47H71.6a.47.47,0,0,1,.47.47Zm0-32.68a.52.52,0,0,1-.52.52H24.12a.52.52,0,0,1-.52-.52V30.39a.53.53,0,0,1,.52-.52H71.55a.52.52,0,0,1,.52.52Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDialogue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DIALOGUE.390fb680.svg";
export { ForwardRef as ReactComponent };